export const normalizeMaterials = (materials: IMaterialPack, uniqueId?: string) => {
  if (!uniqueId) {
    return materials;
  }

  const normalizedMaterials: IMaterialPack = {} as IMaterialPack;

  Object.keys(materials).forEach((key) => {
    const material = (materials as any)[key];
    const newKey = `${key}-${uniqueId}`;
    material.id = newKey;
    (normalizedMaterials as any)[key] = material;
  });

  return normalizedMaterials;
};
